<div *transloco="let t" class="relative py-4">
	<button class="absolute right-2 top-2 z-10" mat-icon-button (click)="cancel()" [attr.aria-label]="t('commonActions.close')">
		<mat-icon>close</mat-icon>
	</button>
	<h1 mat-dialog-title cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane">{{ t('settings.devSettings.supportTools.newMail') }}</h1>

	<mat-dialog-content>
		<form [formGroup]="emailForm" (ngSubmit)="save()">
			<mat-form-field appearance="fill" style="width: 100%">
				<mat-label>{{ t('settings.devSettings.supportTools.mailAddress') }}</mat-label>
				<input matInput formControlName="email" placeholder="name@domain.de" required #emailInput />
				@if (emailForm.get('email')?.hasError('required')) {
					<mat-error>
						{{ t('common.requiredField') }}
					</mat-error>
				}
				@if (emailForm.get('email')?.hasError('email')) {
					<mat-error>
						{{ t('common.enterValidMail') }}
					</mat-error>
				}
			</mat-form-field>
		</form>
	</mat-dialog-content>

	<mat-dialog-actions align="end">
		<button (click)="save()" class="m-2" color="primary" mat-raised-button type="submit" [disabled]="!emailForm.valid">
			<mat-icon>save</mat-icon>
			<span>
				{{ t('commonActions.save') }}
			</span>
		</button>
	</mat-dialog-actions>
</div>
